import React from 'react';
import {Flex, useColorModeValue} from '@chakra-ui/react';
import { FlexProps } from '@chakra-ui/layout/dist/declarations/src/flex';

export default (props: FlexProps) => {
    return (
        <Flex
            width="100%"
            display="inline-flex"
            direction="column"
            background={useColorModeValue(
                'rgba(0, 0, 0, 0.1)',
                'rgba(218, 175, 255, 0.05)'
            )}
            backdropFilter={useColorModeValue(
                'brightness(100%)',
                'brightness(200%)'
            )}
            padding={['1rem', '2rem']}
            borderRadius="0.375rem"
            // overflow="hidden"
            {...props}
        >
            {props?.children}
        </Flex>
    );
};
